var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fusioncharts',{attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataFormat":_vm.dataFormat,"dataSource":_vm.dataSource}})}
var staticRenderFns = []

export { render, staticRenderFns }